/** Если выбрана только часть детей (без взрослого), дизейблим */
export const isFamilyDisabled = (adultId, children, selection) => {
    if (selection[adultId]) {
        return false;
    }
    const childIds = children.map(child => child.id);
    const selectedChildrenCount = childIds.filter(childId => selection[childId]).length;
    if (selectedChildrenCount === 0) {
        return false;
    }
    return selectedChildrenCount < childIds.length;
};
/**
 * Единый источник refund-модели пассажиров:
 *
 * - Взрослый с детьми: `isSelected` — family-чекбокс; `isDisabled` — частичный выбор детей.
 * - Взрослый: `isSelected` — выбор пассажира.
 * - Дети: `isSelected` — child или adult; `isDisabled` — если выбран adult.
 */
export const buildRefundPassengers = (travellers, selection) => {
    /** Добавляем id взрослого для детей */
    const enriched = travellers.map(traveller => {
        var _a;
        return (Object.assign(Object.assign({}, traveller), { parentId: (_a = traveller.linkedTraveller) === null || _a === void 0 ? void 0 : _a.id }));
    });
    const passengers = enriched.map(passenger => {
        const { parentId } = passenger;
        const hasChildren = passenger.type === 'ADT' && enriched.some(linkedPassenger => linkedPassenger.parentId === passenger.id);
        /** Взрослый с детьми */
        if (hasChildren) {
            return Object.assign(Object.assign({}, passenger), { isSelected: Boolean(selection[passenger.id]) });
        }
        /** Взрослый без детей */
        if (passenger.type === 'ADT') {
            return Object.assign(Object.assign({}, passenger), { isSelected: Boolean(selection[passenger.id]) });
        }
        /** Ребенок выбран сам или если выбран его взрослый; при выборе взрослого еще добавляется disabled */
        const parentSelected = parentId ? Boolean(selection[parentId]) : false;
        return Object.assign(Object.assign({}, passenger), { isSelected: Boolean(selection[passenger.id]) || parentSelected, isDisabled: parentSelected });
    });
    /** Добавляет children для ADT + isDisabled при частичном выборе детей без взрослого */
    return passengers.map(passenger => {
        if (passenger.type !== 'ADT') {
            return passenger;
        }
        const children = passengers.filter(linkedPassenger => linkedPassenger.parentId === passenger.id);
        if (children.length === 0) {
            return passenger;
        }
        return Object.assign(Object.assign({}, passenger), { children, isDisabled: isFamilyDisabled(passenger.id, children, selection) });
    });
};
